import src from "IMAGE";
export default { src, width: 446, height: 145, blurWidth: 0, blurHeight: 0};
